module.exports = __webpack_public_path__ + "img/rzlogo_white.ea6b714b.png";